"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.isDownload = isDownload;
exports.shortenName = shortenName;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _xApiStatementFactory = _interopRequireDefault(require("../xApi/xApiStatementFactory"));
var _configOptions = require("../constants/config-options");
var _defaultConfig = require("../config/default-config");
var _formatName = _interopRequireDefault(require("../utils/formatName"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // Copyright 2019 Amplify Inc. All Rights Reserved.
/**
 * @fileoverview EventService provides methods for sending some common xAPI events for webapps.
 * @author jgraham@amplify.com (Jessica Graham)
 */
/**
 * Shorten event value and format with formatName
 * Truncates at right most hyphen and shortens on word
 *
 * @param {String} name Name to shorten.
 * @param {Number} max Max number of chars.
 * @return {String} The formatted name.
 */
function shortenName(name, max) {
  if (!name) return '';
  if (!max) max = 50;
  var formattedName = name;

  // Replaces en-dash and em-dash with normal hyphens.
  formattedName = formattedName.replace(/\u2013|\u2014/g, '-');

  // Truncate on right most hyphen
  if (formattedName.length > max) {
    formattedName = formattedName.slice(0, formattedName.lastIndexOf('-')).trim();
  }

  // Shorten by word
  if (formattedName.length > max) {
    var wordBoundry = formattedName.lastIndexOf(' ');
    while (wordBoundry > max) {
      wordBoundry = formattedName.lastIndexOf(' ', wordBoundry - 1);
    }
    formattedName = formattedName.slice(0, wordBoundry);
  }
  return (0, _formatName["default"])(formattedName);
}

/**
 * Check if anchor file type is download
 *
 * @param {HTMLAnchorElement} element HTMLAnchorElement to check.
 * @return {Boolean} True if it's a download type.
 */
function isDownload(element) {
  for (var t = 0; t < _configOptions.DOWNLOAD_TYPES.length; t++) {
    // Checks for <a href="..." type="application/XXX">
    if (element.type.endsWith("/".concat(_configOptions.DOWNLOAD_TYPES[t]))) {
      return true;
    }
    // Checks for <a href="something.XXX">
    if (element.href.endsWith(".".concat(_configOptions.DOWNLOAD_TYPES[t]))) {
      return true;
    }
  }

  // Anything from Google Drive is a download
  if (element.href.startsWith('https://drive.google.com')) {
    return true;
  }
  return false;
}
var EventService = /*#__PURE__*/function () {
  /**
   * Initialize the service by setting up an event factory with configuration.
   *
   * @param {Object} config
   */
  function EventService(config) {
    var _this$bulkSendConfig;
    _classCallCheck(this, EventService);
    this.stashedEventsKey = "stashedEvents-".concat((0, _formatName["default"])(config[_configOptions.CONFIG_OPTIONS.APP_NAME]), "-") + "".concat(config[_configOptions.CONFIG_OPTIONS.USER_ID]);
    this.config = config;
    this.language = config[_configOptions.CONFIG_OPTIONS.LANGUAGE];
    this.homePage = config[_configOptions.CONFIG_OPTIONS.HOMEPAGE];
    this.sendEventsImmediately = config[_configOptions.CONFIG_OPTIONS.SEND_EVENTS_IMMEDIATELY];
    this.bulkSendConfig = (_this$bulkSendConfig = {}, _defineProperty(_this$bulkSendConfig, _configOptions.BULK_SEND_OPTIONS.USE_BULK_ON_STASHED_EVENTS, config.hasOwnProperty(_configOptions.BULK_SEND_OPTIONS.USE_BULK_ON_STASHED_EVENTS) ? config[_configOptions.BULK_SEND_OPTIONS.USE_BULK_ON_STASHED_EVENTS] : _defaultConfig.defaultBulkSendConfig[_configOptions.BULK_SEND_OPTIONS.USE_BULK_ON_STASHED_EVENTS]), _defineProperty(_this$bulkSendConfig, _configOptions.BULK_SEND_OPTIONS.BULK_STASHED_EVENTS_LIMIT, config.hasOwnProperty(_configOptions.BULK_SEND_OPTIONS.BULK_STASHED_EVENTS_LIMIT) ? config[_configOptions.BULK_SEND_OPTIONS.BULK_STASHED_EVENTS_LIMIT] : _defaultConfig.defaultBulkSendConfig[_configOptions.BULK_SEND_OPTIONS.BULK_STASHED_EVENTS_LIMIT]), _defineProperty(_this$bulkSendConfig, _configOptions.BULK_SEND_OPTIONS.BULK_STASHED_EVENTS_TIMEOUT, config.hasOwnProperty(_configOptions.BULK_SEND_OPTIONS.BULK_STASHED_EVENTS_TIMEOUT) ? config[_configOptions.BULK_SEND_OPTIONS.BULK_STASHED_EVENTS_TIMEOUT] : _defaultConfig.defaultBulkSendConfig[_configOptions.BULK_SEND_OPTIONS.BULK_STASHED_EVENTS_TIMEOUT]), _this$bulkSendConfig);
    this.eventFactory = new _xApiStatementFactory["default"](config, config[_configOptions.CONFIG_OPTIONS.ENVIRONMENT], this.bulkSendConfig[_configOptions.BULK_SEND_OPTIONS.USE_BULK_ON_STASHED_EVENTS], this);
    if (config[_configOptions.CONFIG_OPTIONS.APP_NAME] && config[_configOptions.CONFIG_OPTIONS.USER_ID]) {
      // Send any stashed events.
      this.sendStashedEvents();
    }
  }

  /**
   * Set the display language.
   *
   * @param {String} language
   */
  _createClass(EventService, [{
    key: "setLanguage",
    value: function setLanguage(language) {
      this.language = language;
      this.eventFactory.setLanguage(language);
    }

    /**
     * Set the homepage.
     *
     * @param {String} homePage
     */
  }, {
    key: "setHomePage",
    value: function setHomePage(homePage) {
      this.homePage = homePage;
      this.eventFactory.setHomePage(homePage);
    }

    /**
     * Create a new xAPI event and add basic actor data.
     *
     * @return {Object} The event.
     */
  }, {
    key: "createEvent",
    value: function createEvent() {
      return this.eventFactory.create().addActorAccount('name', this.config[_configOptions.CONFIG_OPTIONS.USER_ID]).addActorAccount('homePage', this.homePage);
    }

    /**
     * Add verb data to an event, representing the action being done. Transforms the passed in event.
     *
     * @param {Object} event
     * @param {String} name The verb name.
     */
  }, {
    key: "addVerb",
    value: function addVerb(event, name) {
      event.addVerbId(name).addVerb('display', _defineProperty({}, this.language, name));
    }

    /**
     * Add object data to an event. Transforms the passed in event.
     * If this is a DOM element, the elementType can be used to set the page-element-type object extension.
     *
     * @param {Object} event
     * @param {String} objectId The id or name of the object being acted on.
     * @param {String?} elementType (Optional) The type of DOM element being acted on.
     * @param {Boolean?} addDefinition (Optional) Whether a definition should be added to the event.
     */
  }, {
    key: "addObject",
    value: function addObject(event, objectId, elementType) {
      var addDefinition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      event.addObjectId(objectId).addObject('objectType', 'Activity');
      if (addDefinition) {
        event.addObjectDefinition('name', objectId);
      }
      if (elementType) {
        event.addObjectExtension('page-element-type', elementType);
      }
    }

    /**
     * Add context data to an event. Transforms the passed in event.
     *
     * @param {Object} event
     * @param {String} key
     * @param {String} value
     */
  }, {
    key: "addContext",
    value: function addContext(event, key, value) {
      event.addContext(key, value);
    }

    /**
     * Add context extension data to an event when there is useful additional context to log. Transforms the passed
     * in event.
     *
     * @param {Object} event
     * @param {Object} extensions
     */
  }, {
    key: "addContextExtensions",
    value: function addContextExtensions(event, extensions) {
      Object.entries(extensions).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        event.addContextExtension(key, value);
      });
    }

    /**
     * Add result data to an event. Transforms the passed in event.
     *
     * @param {Object} event
     * @param {String} key
     * @param {String} value
     */
  }, {
    key: "addResult",
    value: function addResult(event, key, value) {
      event.addResult(key, value);
    }

    /**
     * Add result extensions to an event. Transforms the passed in event.
     *
     * @param {Object} event
     * @param {Object} extensions
     */
  }, {
    key: "addResultExtensions",
    value: function addResultExtensions(event, extensions) {
      Object.entries(extensions).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        event.addResultExtension(key, value);
      });
    }

    /**
     * Stash event in localStorage, to be sent when app is next loaded. Used for events captured on leaving the app.
     * Can only be used on the client side.
     *
     * @param {Object} event
     */
  }, {
    key: "stashEvent",
    value: function () {
      var _stashEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        var stashedEvents, hasEmptyStash;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof window === 'undefined')) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              event.setTimestamp(new Date().toISOString());
              if (global.AMP_EVENTS_DEBUG_LOG) {
                console.log("[amp-events] - ".concat(JSON.stringify(event.statement, null, 2)));
              }
              stashedEvents = localStorage.getItem(this.stashedEventsKey);
              hasEmptyStash = (0, _isEmpty2["default"])(stashedEvents);
              _context.prev = 6;
              stashedEvents = stashedEvents ? JSON.parse(stashedEvents) : [];
              stashedEvents = stashedEvents.concat([event]);
              _context.prev = 9;
              localStorage.setItem(this.stashedEventsKey, JSON.stringify(stashedEvents));
              _context.next = 22;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](9);
              if (!hasEmptyStash) {
                _context.next = 20;
                break;
              }
              console.error('amp-events - failed to stash event with an empty stash');
              return _context.abrupt("return", this.eventFactory.bulkEmit(stashedEvents));
            case 20:
              console.error('amp-events - failed to stash event with existing stash size', stashedEvents.length);
              // flush all stashed events, and retry
              return _context.abrupt("return", this.sendEvents([event], stashedEvents.length));
            case 22:
              return _context.abrupt("return", this.sendEvents(undefined, stashedEvents.length));
            case 25:
              _context.prev = 25;
              _context.t1 = _context["catch"](6);
              console.error(_context.t1);
            case 28:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6, 25], [9, 13]]);
      }));
      function stashEvent(_x2) {
        return _stashEvent.apply(this, arguments);
      }
      return stashEvent;
    }()
  }, {
    key: "sendEvents",
    value: function () {
      var _sendEvents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var additionalEvents,
          stashedEventsLength,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              additionalEvents = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : [];
              stashedEventsLength = _args2.length > 1 ? _args2[1] : undefined;
              if (!this.sendEventsImmediately) {
                _context2.next = 7;
                break;
              }
              _context2.next = 5;
              return this.sendStashedEvents();
            case 5:
              _context2.next = 10;
              break;
            case 7:
              if (!(this.bulkSendConfig[_configOptions.BULK_SEND_OPTIONS.USE_BULK_ON_STASHED_EVENTS] && this.bulkSendConfig[_configOptions.BULK_SEND_OPTIONS.BULK_STASHED_EVENTS_LIMIT] <= stashedEventsLength)) {
                _context2.next = 10;
                break;
              }
              _context2.next = 10;
              return this.sendStashedEventsWithBulk(additionalEvents);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function sendEvents() {
        return _sendEvents.apply(this, arguments);
      }
      return sendEvents;
    }()
    /**
     * Send any events that have been stashed in localStorage.
     * Can only be used on the client side.
     *
     * @return {Promise}
     */
  }, {
    key: "sendStashedEvents",
    value: function sendStashedEvents() {
      var _this = this;
      if (typeof window === 'undefined') return;

      // sending stashed events from local storage as bulk using batch endpoint when feature enabled during init
      if (this.bulkSendConfig[_configOptions.BULK_SEND_OPTIONS.USE_BULK_ON_STASHED_EVENTS] && !this.sendEventsImmediately) {
        return this.sendStashedEventsWithBulk();
      }
      var stashedEvents = localStorage.getItem(this.stashedEventsKey);
      var promises = [];
      if (stashedEvents) {
        try {
          JSON.parse(stashedEvents).forEach(function (stashedEvent) {
            var event = _this.createEvent();
            event.statement = Object.assign(event.statement, stashedEvent.statement);
            promises.push(event.emit());
          });
        } catch (error) {
          console.error(error);
        }
        localStorage.removeItem(this.stashedEventsKey);
      }
      return Promise.all(promises);
    }

    /**
     * Send any events that have been stashed in localStorage as bulk using batch endpoint
     * Can only be used on the client side.
     *
     * @param {Array} additionalEvents - any events that should be sent in addition to
     *  what is currently in localStorage
     * @return {Promise}
     */
  }, {
    key: "sendStashedEventsWithBulk",
    value: function () {
      var _sendStashedEventsWithBulk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this2 = this;
        var additionalEvents,
          stashedEvents,
          eventsBulk,
          parsedStashedEvents,
          _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              additionalEvents = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : [];
              stashedEvents = localStorage.getItem(this.stashedEventsKey);
              eventsBulk = [];
              if (stashedEvents) {
                try {
                  parsedStashedEvents = JSON.parse(stashedEvents);
                  parsedStashedEvents = parsedStashedEvents.concat(additionalEvents);
                  parsedStashedEvents.forEach(function (stashedEvent) {
                    var event = _this2.createEvent();
                    event.statement = Object.assign(event.statement, stashedEvent.statement);
                    eventsBulk.push(event);
                  });
                } catch (error) {
                  console.error(error);
                }
                localStorage.removeItem(this.stashedEventsKey);
                // reset timer if events are sent using bulk
                sessionStorage.setItem(_configOptions.BULK_SEND_OPTIONS.BULK_SEND_TIMER_SESSION_STORAGE_KEY, '0');
              }
              return _context3.abrupt("return", this.eventFactory.bulkEmit(eventsBulk));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function sendStashedEventsWithBulk() {
        return _sendStashedEventsWithBulk.apply(this, arguments);
      }
      return sendStashedEventsWithBulk;
    }()
    /**
     * Send an xAPI event when an app is loaded.
     *
     * @param {Object?} contextExtensions Optional data representing the context for the event.
     * @param {Object?} resultExtensions Optional data representing the result for the event.
     *
     * @return {Promise}
     */
  }, {
    key: "sendAppLoadedEvent",
    value: function sendAppLoadedEvent(contextExtensions, resultExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'loaded');
      this.addObject(event, this.config[_configOptions.CONFIG_OPTIONS.APP_NAME]);
      if (contextExtensions) {
        this.addContextExtensions(event, contextExtensions);
      }
      if (resultExtensions) {
        this.addResultExtensions(event, resultExtensions);
      }
      return event.emit();
    }

    /**
     * Send an xAPI event when the app is unloaded.
     *
     * @param {Object?} contextExtensions Optional data representing the context for the event.
     * @param {Object?} resultExtensions Optional data representing the result for the event.
     *
     * @return {Promise}
     */
  }, {
    key: "sendAppUnloadedEvent",
    value: function sendAppUnloadedEvent(contextExtensions, resultExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'unloaded');
      this.addObject(event, this.config[_configOptions.CONFIG_OPTIONS.APP_NAME]);
      if (contextExtensions) {
        this.addContextExtensions(event, contextExtensions);
      }
      if (resultExtensions) {
        this.addResultExtensions(event, resultExtensions);
      }
      return event.emit();
    }

    /**
     * Stash an xAPI event when the app is unloaded.
     * Should only be used on the client side.
     *
     * @param {Object?} contextExtensions Optional data representing the context for the event.
     * @param {Object?} resultExtensions Optional data representing the result for the event.
     */
  }, {
    key: "stashAppUnloadedEvent",
    value: function stashAppUnloadedEvent(contextExtensions, resultExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'unloaded');
      this.addObject(event, this.config[_configOptions.CONFIG_OPTIONS.APP_NAME]);
      if (contextExtensions) {
        this.addContextExtensions(event, contextExtensions);
      }
      if (resultExtensions) {
        this.addResultExtensions(event, resultExtensions);
      }
      this.stashEvent(event);
    }

    /**
     * Send an xAPI event when a page is opened.
     *
     * @param {String} page The page name or path.
     * @param {Object?} contextExtensions Optional data representing the context for the event.
     * @param {Object?} resultExtensions Optional data representing the result for the event.
     * @return {Promise}
     */
  }, {
    key: "sendPageOpenedEvent",
    value: function sendPageOpenedEvent(page, contextExtensions, resultExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'opened');
      this.addObject(event, 'webpage');
      event.addObjectDefinition('location', page);
      if (contextExtensions) {
        this.addContextExtensions(event, contextExtensions);
      }
      if (resultExtensions) {
        this.addResultExtensions(event, resultExtensions);
      }
      return event.emit();
    }

    /**
    * Send an xAPI event when a page is opened.
    *
    * @param {String} pageName The page name (typically the <title> elsment value).
    * @param {String} pagePath The page name or path.
    * @param {Object?} contextExtensions Optional data representing the context for the event.
    * @param {Object?} resultExtensions Optional data representing the result for the event.
    * @return {Promise}
    */
  }, {
    key: "sendPageViewedEvent",
    value: function sendPageViewedEvent(pageName, pagePath, contextExtensions, resultExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'viewed');
      this.addObject(event, shortenName(pageName, 25));
      event.addObjectDefinition('location', pagePath);
      if (contextExtensions) {
        this.addContextExtensions(event, contextExtensions);
      }
      if (resultExtensions) {
        this.addResultExtensions(event, resultExtensions);
      }
      return event.emit();
    }

    /**
     * Send an xAPI event when a page is closed.
     *
     * @param {String} page The page name or path.
     * @param {Object?} contextExtensions Optional data representing the context for the event.
     * @param {Object?} resultExtensions Optional data representing the result for the event.
     * @return {Promise}
     */
  }, {
    key: "sendPageClosedEvent",
    value: function sendPageClosedEvent(page, contextExtensions, resultExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'closed');
      this.addObject(event, 'webpage');
      event.addObjectDefinition('location', page);
      if (contextExtensions) {
        this.addContextExtensions(event, contextExtensions);
      }
      if (resultExtensions) {
        this.addResultExtensions(event, resultExtensions);
      }
      return event.emit();
    }

    /**
     * Stash an xAPI event when a page is closed.
     * Should only be used on the client side.
     *
     * @param {String} page The page name or path.
     * @param {Object?} contextExtensions Optiional data representing the context for the event.
     * @param {Object?} resultExtensions Optional data representing the result for the event.
     */
  }, {
    key: "stashPageClosedEvent",
    value: function stashPageClosedEvent(page, contextExtensions, resultExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'closed');
      this.addObject(event, 'webpage');
      event.addObjectDefinition('location', page);
      if (contextExtensions) {
        this.addContextExtensions(event, contextExtensions);
      }
      if (resultExtensions) {
        this.addResultExtensions(event, resultExtensions);
      }
      this.stashEvent(event);
    }
  }]);
  return EventService;
}();
exports["default"] = EventService;